import { storylaneDemoUrl } from '../consts'

interface Props {
  demoId: string
  title: string
  aspectRatioPercent: number
  chromeHeightPx: number
}

export function StorylaneEmbed({
  demoId,
  title,
  aspectRatioPercent,
  chromeHeightPx,
}: Props) {
  return (
    <div
      className="sl-embed relative h-0 w-full"
      style={{
        paddingBottom: `calc(${aspectRatioPercent}% + ${chromeHeightPx}px)`,
      }}
    >
      <iframe
        className="sl-demo absolute inset-0 h-full w-full rounded-xl border border-stone-200 shadow-card"
        src={storylaneDemoUrl(demoId)}
        title={title}
        name="sl-embed"
        loading="lazy"
        allow="fullscreen"
        allowFullScreen
      />
    </div>
  )
}
